import * as React from 'react';
import { SVGProps } from 'react';

const RoundCheckIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12Z" />
      <path d="M10.665 6.667 7.332 10l-2-2" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default RoundCheckIcon;
